export default "__VITE_ASSET__BDGfJydd__"